import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" fill="none" fillRule="evenodd" xmlns="http://www.w3.org/2000/svg" {...props}><path clipRule="evenodd" d="M12 17.7l8.4 5.1V2.4H3.6v20.4l8.4-5.1zm-7.35 3.162L12 16.4l7.35 4.462V3.533H4.65v17.33z" /></svg>;